export function axonTracker(eventName, eventData = {}) {
  if (typeof window.axon === 'function') {
    console.log('Axon', eventName, eventData);

    try {
      // Follows the Axon Pixel API: axon("track", «event-name», «event-data»)
      // See: https://support.axon.ai/en/growth/promoting-your-websites/axon-pixel-integration/google-tag-manager
      if (eventName === 'page_view') {
        window.axon('track', 'page_view');
      } else {
        window.axon('track', eventName, eventData);
      }
    } catch (error) {
      console.error('Error tracking Axon event', error);
    }
  }
}

function toNumber(value, fallback = 0) {
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function buildSingleItemEventData(price, contentId, extra = {}) {
  const normalizedPrice = toNumber(price, 0);
  const itemId = String(contentId ?? '');

  return {
    items: [
      {
        item_id: itemId,
        item_name: itemId,
        price: normalizedPrice,
        quantity: 1,
      },
    ],
    value: normalizedPrice,
    currency: 'USD',
    ...extra,
  };
}

// Required events for purchase sites:
// https://support.axon.ai/en/growth/promoting-your-websites/axon-pixel-integration/events-and-objects#required-events-for-purchase-sites
export function axonPageView() {
  axonTracker('page_view');
}

export function axonCompleteRegistration() {
  axonTracker('sign_up', { method: 'email' });
}

export function axonViewItem(price, contentId) {
  axonTracker('view_item', buildSingleItemEventData(price, contentId));
}

export function axonAddToCart(price, contentId) {
  axonTracker('add_to_cart', buildSingleItemEventData(price, contentId));
}

export function axonInitiateCheckout(trialPrice, contentId) {
  axonTracker(
    'begin_checkout',
    buildSingleItemEventData(trialPrice, contentId)
  );
}

export function axonCompletePayment(
  trialPrice,
  contentId,
  transactionId,
  { shipping = 0, tax = 0 } = {}
) {
  const data = buildSingleItemEventData(trialPrice, contentId, {
    transaction_id: transactionId,
    shipping: toNumber(shipping, 0),
    tax: toNumber(tax, 0),
  });
  axonTracker('purchase', data);
}
